import { useNoOrgExperience } from '@townsquare/org-context';
import { createRouterSelector } from '@townsquare/router/createRouterSelector';
import { HomepageRoute, HomepageRouteType } from '@townsquare/router/route-types';

import { noWorkspaceRoutes, routes } from './routes';

export const useRoute: (args_0: void) => HomepageRoute = createRouterSelector<HomepageRoute>(
	(o) => o.route as HomepageRoute,
);

export const useTeamsRoutes = (): HomepageRouteType[] => {
	const noOrgExperience = useNoOrgExperience();
	return noOrgExperience ? noWorkspaceRoutes : routes;
};
